import { BaseResponseCode } from 'shared/entities/network';

export const mapManagerCreateErrorCodeToTitle: Record<
  BaseResponseCode.conflict,
  string
> = {
  [BaseResponseCode.conflict]: 'Менеджер с таким email уже существует'
};
